<template>
  <v-card class="elevation-2" :loading="loading">
    <v-list>
      <v-list-item three-line>
        <v-list-item-avatar>
          <v-btn color="blue-grey" outlined icon small @click="$router.go(-1)">
            <v-icon>mdi-arrow-left-bold</v-icon>
          </v-btn>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="wrap-text">{{ oficio.numeroCompleto }} -
            {{ oficio.asunto }}</v-list-item-title>
          <v-list-item-subtitle>{{
            oficio.fecha? formatoFecha(oficio.fecha): ''
          }}</v-list-item-subtitle>
          <v-list-item-subtitle
            >Status: {{ oficio.status }}</v-list-item-subtitle
          >
          <v-list-item-subtitle v-if="!oficio.relacionado.id">
            <span v-if="notificaciones">Notificaciones activas</span>
            <span v-else>Notificaciones desactivadas</span>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-menu offset-y left>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" x-small outlined icon fab :disabled="loadingNotif">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item v-if="!oficio.relacionado.id" dense @click="notificacionesOficio()">
                <v-list-item-icon class="list-icon">
                  <v-icon v-if="notificaciones" class="icon-size">mdi-bell-off</v-icon>
                  <v-icon v-else class="icon-size">mdi-bell</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  <span v-if="notificaciones">Desactivar notificaciones</span>
                  <span v-else>Activar notificaciones</span>
                </v-list-item-title>
              </v-list-item>

              <v-list-item v-if="!soloLectura" @click="modificarOficio = true">
                <v-list-item-icon class="list-icon">
                  <v-icon class="icon-size">mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Modificar oficio</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="oficio.relacionado.id && !soloLectura" @click="quitarRespuesta.mostrar = true">
                <v-list-item-icon class="list-icon">
                  <v-icon class="icon-size">fa-unlink</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Desvincular oficio</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="!soloLectura" @click="eliminar.mostrar = true">
                <v-list-item-icon class="list-icon">
                  <v-icon class="icon-size" color="red darken-1">mdi-trash-can</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    <font color="#C00"> Eliminar oficio</font>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-container>
      <v-row wrap>
        <v-col md="12">
          <documentos-adjuntos :files="oficio.files" :id="oficio._id" :soloLectura="soloLectura"
            :numero="oficio.numeroCompleto" tipo="generado" @documentoCargado="documentoCargado"
            @documentoEliminado="documentoEliminado"  @nuevoLog="nuevo => $emit('nuevoLog', nuevo)" />
        </v-col>
        <v-col md="5">
          <v-card outlined>
            <v-toolbar dense flat color="blue-grey lighten-5" height="30">
              <v-toolbar-title class="subtitle-1">Emisor</v-toolbar-title>
            </v-toolbar>

            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title>{{ emisor.titular }}</v-list-item-title>
                <v-list-item-subtitle>{{ emisor.puesto }}</v-list-item-subtitle>
                <v-list-item-title>{{ emisor.dependencia }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col md="7">
          <v-card outlined>
            <v-toolbar dense flat color="blue-grey lighten-5" height="30">
              <v-toolbar-title class="subtitle-1">Destinatario</v-toolbar-title>
            </v-toolbar>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title>{{
    oficio.destinatario.responsable
  }}</v-list-item-title>
                <v-list-item-subtitle>{{
      oficio.destinatario.cargo
    }}</v-list-item-subtitle>
                <v-list-item-title>{{
      oficio.destinatario.entidad.nombre
    }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col md="6">
          <v-card outlined>
            <v-toolbar dense flat color="blue-grey lighten-5" height="30">
              <v-toolbar-title class="subtitle-1">Generó</v-toolbar-title>
            </v-toolbar>

            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title>{{ oficio.emisor.usuario.titulo }}
                  {{ oficio.emisor.usuario.nombreCompleto }}</v-list-item-title>
                <v-list-item-subtitle>{{
    oficio.emisor.cargo
  }}</v-list-item-subtitle>
                <v-list-item-title>{{
      oficio.emisor.dependencia.nombre
    }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col md="12">
          <v-card outlined>
            <v-toolbar dense flat color="blue-grey lighten-5" height="30">
              <v-toolbar-title class="subtitle-1">Datos del oficio:</v-toolbar-title>
            </v-toolbar>
            <v-row>
              <v-col md="2">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Tipo documento:</v-list-item-subtitle>
                    <v-list-item-title>{{
      oficio.tipoDocumento
    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col md="2">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Documentos:</v-list-item-subtitle>
                    <v-list-item-title>{{
      oficio.documentos
    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col md="3">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Fecha de recepción:</v-list-item-subtitle>
                    <v-list-item-title v-if="oficio.fechaRecibido">{{
                      oficio.fechaRecibido && formatoFecha(oficio.fechaRecibido)
                    }}</v-list-item-title>
                    <v-list-item-title v-else
                      ><i>No capturado</i></v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col md="2">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Documento:</v-list-item-subtitle>
                    <v-list-item-title>{{
      oficio.original ? "Original" : "Copia"
    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col md="3">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Fecha límite de respuesta:</v-list-item-subtitle>
                    <v-list-item-title>{{
                      oficio.fechaRespuesta
                        ? formatoFecha(oficio.fechaRespuesta)
                        : "No solicitado"
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col md="4">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Recibió:</v-list-item-subtitle>
                    <v-list-item-title>{{ oficio.recibio }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>

              <v-col md="5">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Observaciones:</v-list-item-subtitle>
                    <v-list-item-title>{{
                                          oficio.observaciones
                                        }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col md="4">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Capturó:</v-list-item-subtitle>
                    <v-list-item-title>{{ oficio.captura.usuario.titulo }}
                      {{
                        oficio.captura.usuario.nombreCompleto
                      }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col md="3">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-subtitle>Fecha de captura:</v-list-item-subtitle>
                    <v-list-item-title>{{
                      oficio.captura.fecha && formatoFechaHora(oficio.captura.fecha)
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col md="12">
          <usuarios-compartido-generado v-if="!oficio.relacionado.id" :emisor="oficio.emisor.usuario"
            :compartido="oficio.compartido" :soloLectura="soloLectura" tipo="generado" :idOficio="idOficio"
            @compartidoModificado="compartidoModificado" @permisoModificado="permisoModificado"  @nuevoLog="nuevo => $emit('nuevoLog', nuevo)"  />
        </v-col>

        <v-col md="12">
          <cpp-oficio :idOficio="idOficio" tipo="generado" :soloLectura="soloLectura" :ccp="oficio.ccp"
            @ccpAgregado="ccpAgregado" @ccpRemovido="ccpRemovido" />
        </v-col>
      </v-row>
    </v-container>

    <!-- SECCION PARA MODIFICAR -->
    <modificar-oficio-generado
      v-if="modificarOficio"
      :mostrar="modificarOficio"
      :oficio="oficio"
      :esPadre="esPadre"
      @cancelar="modificarOficio = false"
      @oficioModificado="oficioModificado"
      @nuevoLog="nuevo => $emit('nuevoLog', nuevo)"
    />

    <mensaje-confirmar :mostrar="quitarRespuesta.mostrar" :titulo="quitarRespuesta.titulo"
      :texto="quitarRespuesta.texto" @cancelar="quitarRespuesta.mostrar = false" @aceptar="quitarRelacion()" />

    <confirmar-eliminar :mostrar="eliminar.mostrar" :titulo="eliminar.titulo" :texto="eliminar.texto"
      @cancelar="eliminar.mostrar = false" @aceptar="eliminarOficio()" />
  </v-card>
</template>

<script>
import axios from "axios";
import {DateTime,Settings} from 'luxon';
import { mapGetters } from "vuex";
// import SubirDocumento from "./subirDocumento";
import DocumentosAdjuntos from "./documentosAdjuntos";
import UsuariosCompartidoGenerado from "./usuariosCompartidoGenerado";
import cppOficio from "./cppOficio";
import ModificarOficioGenerado from "./modificarOficioGenerado.vue";
import MensajeConfirmar from "../MainTemplate/mensajeConfirmar";
import ConfirmarEliminar from "../MainTemplate/mensajeConfirmar";
import { cargarOficioGeneradoByIdService } from "./oficiosGenerados.service";

Settings.defaultLocale = 'es';

export default {
  props: ["idOficio", "soloLectura", "esPadre"],
  components: {
    // SubirDocumento,
    DocumentosAdjuntos,
    UsuariosCompartidoGenerado,
    cppOficio,
    ModificarOficioGenerado,
    MensajeConfirmar,
    ConfirmarEliminar,
  },
  watch: {
    idOficio(nuevo, anterior) {
      this.cargarOficio();
    },
  },
  computed: {
    ...mapGetters(["httpURL", "sessionToken", "userId"]),
    emisor() {
      // console.log(DateTime.fromFormat(fecha, "yyyy-MM-dd") )
      if(this.oficio.captura.fecha!=undefined){
      let emisor = {}

      let emisoresSelect = this.emisorestmp.filter((x) => x.numero == this.oficio.numero.dependencia)
      
      let ff= this.oficio.captura.fecha.split(' ')

      let fechaOficio = DateTime.fromISO(ff[0])
      emisoresSelect.forEach(x=>{

        let inicio = DateTime.fromISO(x.periodoInicio)
        let fin = DateTime.fromISO(x.periodoFin)

        if(fechaOficio >= inicio && fechaOficio <= fin) emisor = x 
      })
      return emisor;
      }
      return {}
    },
  },
  data: () => ({
    loading: false,
    loadingNotif: false,
    emisores: [],
    oficio: {
      numero: {},
      emisor: { dependencia: {}, usuario: {} },
      captura: { usuario: {} },
      destinatario: { entidad: {} },
      relacionado: {},
      ccp: [],
      files: [],
    },
    notificaciones: true,
    modificarOficio: false,
    quitarRespuesta: {
      mostrar: false,
      titulo: "Quitar respuesta",
      texto:
        "¿Está seguro de quitar este oficio como respuesta? <br>Esta acción no eliminará el oficio del sistema.",
    },
    relacionar: false,
    eliminar: {
      mostrar: false,
      titulo: "Eliminar oficio",
      texto:
        "¿Está seguro de eliminar este oficio? <br>Esta acción acción no se podrá revertir.",
    },
    emisorestmp:[]
  }),
  created() {
    this.cargarOficio();
  },
  methods: {
    async cargarOficio() {
      try {
        this.loading = true;
        const serverResponse = await cargarOficioGeneradoByIdService(
          this.idOficio
        );
        this.loading = false;
        if (!serverResponse.ok) throw new Error(serverResponse.mensaje);

        this.oficio = serverResponse.oficio;
        this.emisores = serverResponse.emisores;

        this.emisores.forEach( x => {
          let obj = x
            if(x.numero == 'I'){
                if(x.titular == 'Mtro. Guillermo Arturo Gómez Mata') {
                  obj.periodoInicio = '2019-01-01',
                  obj.periodoFin = '2025-03-30'
                }
                //TODO- Aun falta validar este
                // else if(x.titular == "Mtro. Carlos Oscar Trejo Herrera") obj.nota = `${x.numero} Mtro. Carlos Oscar Trejo Herrera`
                else if (x.titular == "Mtro. César Antonio Barba Delgadillo") {
                  obj.periodoInicio = '2025-04-01'
                  obj.periodoFin = '2031-03-30'
                }
            }
            else if(x.numero == 'II'){
            if(x.titular == 'Mtra. Karla Ávila Ramos') {
                  obj.periodoInicio = '2019-01-01'
                  obj.periodoFin = '2025-03-30'
                }
            else if(x.titular == "Mtra. Isela Ramirez Valadez") {
                  obj.periodoInicio = '2025-04-01'
                  obj.periodoFin = '2031-03-30'
                }
            }
            else if(x.numero == 'III'){
            if(x.titular == 'Mtro. Jesús Alberto Jiménez Herrera') {
                  obj.periodoInicio = '2025-04-01'
                  obj.periodoFin = '2031-03-30'
                }
            else if(x.titular == "Dr. Paulo Alberto Carrillo Torres") {
                  obj.periodoInicio = '2019-01-01'
                  obj.periodoFin = '2025-03-31'
                }
            }
            else if(x.numero == 'IV'){
            if(x.titular == 'Mtra. Marcela Sinaí Villalpando Barrios') {
                  obj.periodoInicio='2025-05-01'
                  obj.periodoFin='2031-03-30'
                }
            else if(x.titular == "Mtro. Marco Antonio Romero Güemez") {
                  obj.periodoInicio='2019-01-01'
                  obj.periodoFin='2025-04-30'
                }
            }
            else if(x.numero == 'V'){
            if(x.titular == 'Dr. Ricardo Villanueva Lomelí') {
                  obj.periodo='2019-01-01'
                  obj.periodoFin='2025-03-31'
                }
            else if(x.titular == "Mtra. Karla Alejandrina Planter Pérez") {
                  obj.periodoInicio='2025-04-01'
                  obj.periodoFin='2031-03-31'
                }
            }
            this.emisorestmp.push(obj)
          })
        this.notificaciones = serverResponse.notificaciones;
        this.$emit("oficioCargado", this.oficio.historico);
        this.$emit("setSoloLectura", serverResponse.soloLectura);
      } catch (error) {
        this.loading = false;
        this.$notificarError(error.message);
      }
    },
    formatoFecha(fecha) {
      let f = fecha.split(' ')
      return DateTime.fromISO(f[0]).toFormat("dd 'de' LLLL 'de' yyyy");
    },
    formatoFechaHora(fecha) {
      let dateTime = DateTime.fromFormat(fecha, "yyyy-MM-dd");
      if(!dateTime.isValid) dateTime = DateTime.fromFormat(fecha, "yyyy-MM-dd TT");
      return dateTime.toFormat("dd 'de' LLLL 'de' yyyy HH:mm 'hrs.'")
    },
    documentoCargado(nuevoDocumento) {
      this.oficio.files.push(nuevoDocumento);
    },
    documentoEliminado(id) {
      let index = this.oficio.files.findIndex((x) => x._id == id);
      this.oficio.files.splice(index, 1);
    },
    compartidoModificado(compartido) {
      this.oficio.compartido = compartido;
    },
    permisoModificado(usuario) {
      let index = this.oficio.compartido.findIndex(
        (x) => x.usuario._id == usuario
      );
      this.oficio.compartido[index].soloLectura =
        !this.oficio.compartido[index].soloLectura;
    },
    oficioModificado() {
      this.loading = true;
      axios
        .get(this.httpURL + "/oficios/generado/" + this.idOficio, {
          headers: { token: this.sessionToken },
        })
        .then((res) => {
          // console.log(res.data);
          if (res.data.ok) {
            this.oficio = res.data.oficio;
            this.$emit("oficioCargado", this.oficio.historico);
            this.modificarOficio = false;
          } else {
            this.$notify({
              group: "gral_notif",
              type: "error",
              duration: 1500,
              speed: 500,
              text: res.data.mensaje,
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          // console.log('Error: '+error);
          this.loading = false;
          this.$notify({
            group: "gral_notif",
            type: "error",
            duration: 1500,
            speed: 500,
            text: "Ocurrió un error al hacer la petición",
          });
        });
    },
    quitarRelacion() {
      this.loading = true;
      axios
        .put(
          this.httpURL + "/oficios/generado/quitarRelacion/" + this.idOficio,
          {},
          { headers: { token: this.sessionToken } }
        )
        .then((res) => {
          // console.log(res.data);
          if (res.data.ok) {
            this.quitarRespuesta.mostrar = false;
            this.$emit(
              "oficioRemovido",
              res.data.idOficio,
              res.data.comentario
            );
            this.$emit('nuevoLog')
          } else {
            this.$notify({
              group: "gral_notif",
              type: "error",
              duration: 1500,
              speed: 500,
              text: res.data.mensaje,
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          // console.log('Error: '+error);
          this.loading = false;
          this.$notify({
            group: "gral_notif",
            type: "error",
            duration: 1500,
            speed: 500,
            text: "Ocurrió un error al hacer la petición",
          });
        });
    },
    notificacionesOficio() {
      this.loadingNotif = true;
      axios
        .put(
          this.httpURL + "/oficios/generado/notificaciones/" + this.idOficio,
          {},
          { headers: { token: this.sessionToken } }
        )
        .then((res) => {
          // console.log(res.data);
          if (res.data.ok) {
            this.notificaciones = res.data.notificaciones;
          } else {
            this.$notify({
              group: "gral_notif",
              type: "error",
              duration: 1500,
              speed: 500,
              text: res.data.mensaje,
            });
          }
          this.loadingNotif = false;
        })
        .catch((error) => {
          // console.log('Error: '+error);
          this.loadingNotif = false;
          this.$notify({
            group: "gral_notif",
            type: "error",
            duration: 1500,
            speed: 500,
            text: "Ocurrió un error al hacer la petición",
          });
        });
    },
    ccpAgregado(ccp) {
      this.oficio.ccp.push(ccp);
    },
    ccpRemovido(id) {
      this.oficio.ccp = this.oficio.ccp.filter((x) => x._id != id);
    },
    eliminarOficio() {
      this.loading = true;
      axios
        .delete(this.httpURL + "/oficios/generado/" + this.idOficio, {
          headers: { token: this.sessionToken },
        })
        .then((res) => {
          // console.log(res.data);
          if (res.data.ok) {
            this.eliminar.mostrar = false;
            this.$emit("oficioEliminado", this.idOficio);
          } else {
            this.$notify({
              group: "gral_notif",
              type: "error",
              duration: 1500,
              speed: 500,
              text: res.data.mensaje,
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          // console.log('Error: '+error);
          this.loading = false;
          this.$notify({
            group: "gral_notif",
            type: "error",
            duration: 1500,
            speed: 500,
            text: "Ocurrió un error al hacer la petición",
          });
        });
    },
  },
};
</script>

<style>
.list-icon {
  margin-right: 10px !important;
  margin-top: 10px !important;
}

.icon-size {
  font-size: 20px !important;
}

.wrap-text {
  white-space: normal;
}
</style>